import React from 'react'
import CurrencySelector from 'components/fields/CurrencySelector'
import * as selectors from 'selectors'
import { connect } from 'react-redux'

const SelectCrypto = ({ currencies, ...props }) => (
  <CurrencySelector currencies={currencies} {...props} />
)

const mapStateToProps = (state, ownProps) => ({
  currencies: ownProps.cryptos
    ? selectors
        .cryptoArray(state)
        .filter(c => ownProps.cryptos.indexOf(c.code) > -1)
    : selectors.cryptoArray(state),
})

export default connect(mapStateToProps)(SelectCrypto)



// WEBPACK FOOTER //
// ./src/components/fields/SelectCrypto.js